import { useState, useEffect } from "react";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import { ColDef, ValueGetterParams } from "ag-grid-community";
import {AG_GRID_LOCALE_IT} from "@ag-grid-community/locale";
import { History } from "../../services/models/output-objs/historyOutput";
import CONSTANTS from "../../shared/utils/Constants";

type SegnalazioniCollegateTableType = {
    elements : History[],
    user:any,
}

const SegnalazioniCollegateGrid = ({elements, user} : SegnalazioniCollegateTableType) => {


    useEffect(() => {
        setRowData(elements)
    }, [elements])

    const [rowData, setRowData] = useState<History[]>(elements);

    const defaultColDef: ColDef = {
        resizable: false
    };

    // Column Definitions: Defines & controls grid columns.
    const [colDefsInt] = useState<ColDef<History>[]>([
        { headerName: 'Identificativo', flex:1, valueGetter: (p: ValueGetterParams) => p.data.to},
        { headerName: 'Prot. Consob', flex:2, valueGetter: (p: ValueGetterParams) => p.data.protocolNumber},
        { headerName: 'Soggetto Segnalante', flex:2, valueGetter: (p: ValueGetterParams) => p.data.reportingSubject},
        { headerName: 'Strumento Finanziario', flex:2, valueGetter: (p: ValueGetterParams) => p.data.financialString},
        { headerName: 'Azione', flex:2, valueGetter: (p: ValueGetterParams) => getStateStorHisotry(p.data)},
        { headerName: 'Stato', flex:1, valueGetter: (p: ValueGetterParams) => p.data.state},
    ]);

    const [colDefsExt] = useState<ColDef<History>[]>([
        { headerName: 'Prot. Consob', flex:1, valueGetter: (p: ValueGetterParams) => p.data.protocolNumber},
        { headerName: 'Soggetto Segnalante', flex:2, valueGetter: (p: ValueGetterParams) => p.data.reportingSubject},
        { headerName: 'Strumento Finanziario', flex:2, valueGetter: (p: ValueGetterParams) => p.data.financialString},
        { headerName: 'Azione', flex:2, valueGetter: (p: ValueGetterParams) => getStateStorHisotry(p.data)},
        { headerName: 'Stato', flex:1, valueGetter: (p: ValueGetterParams) => p.data.state},

    ]);

    const localeText = AG_GRID_LOCALE_IT;

    function getStateStorHisotry(element : any){
        if(!element.from)
            return "Partenza"
        if(element.type === 'INTEGRAZIONE'){
            if(user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole))
                return "Integrazione della " + element.from  
            else
                return "Integrazione della " + element.protocolNumber 
        }
        if(element.type === 'RICARICAMENTO'){
            if(user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole))
                return "Aggiornamento della " + element.from  
            else
                return "Aggiornamento della " + element.protocolNumber 
        }
    }

    return (
        <div>
            {user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole) ?
                <div className="ag-theme-quartz-dark mt-3" style={{ width: '100%', border:'none'}}>
                    <AgGridReact 
                        rowData={rowData} 
                        columnDefs={colDefsInt}
                        defaultColDef={defaultColDef}
                        domLayout={"autoHeight"}
                        localeText={localeText}
                    />
                </div>
                :
                <div className="ag-theme-quartz-dark mt-3" style={{ width: '100%', border:'none'}}>
                    <AgGridReact 
                        rowData={rowData} 
                        columnDefs={colDefsExt}
                        defaultColDef={defaultColDef}
                        domLayout={"autoHeight"}
                        localeText={localeText}
                    />
                </div>
        }</div>
    );

}

export default SegnalazioniCollegateGrid
